// extracted by mini-css-extract-plugin
export default {"k8slogo":"PolicyKindSelector_k8slogo_XQsuv","k8Slogo":"PolicyKindSelector_k8slogo_XQsuv","ciliumlogo":"PolicyKindSelector_ciliumlogo_vSNPH"};